export const LOGIN_ROUTE = '/login';
export const ACCESS_DENIED_ROUTE = '/access-denied';
export const LICENSE_AGREEMENT_ROUTE = '/license-agreement';
export const DELIVERIES_ROUTE = '/deliveries';
export const DELIVERY_ROUTE = '/delivery';
export const LABELING_ROUTE = '/labeling';
export const LOADING_ROUTE = '/loading';
